import React from "react";
import { BodyText } from "../BodyText";
import { useUtilityStyles } from "../hooks/useUtilityStyles";
import { THEME } from "../theming/theming";
import { classNames } from "../utils/classNames";
export const Prompt = ({ message, type = "warning", className, styleOptions, role, hideMessage, }) => {
    let glyph = "exclamationSign";
    let color = THEME.palette.warning.base.color;
    if (type === "success") {
        glyph = "circleCheck";
        color = THEME.palette.success.base.color;
    }
    if (type === "error") {
        glyph = "circleAlert";
        color = THEME.palette.error.base.color;
    }
    if (type === "locked") {
        glyph = "lock";
        color = THEME.palette.gray.slate.color;
    }
    if (type === "info") {
        glyph = "infoSign";
        color = THEME.palette.primary.base.color;
    }
    const utilityStyles = useUtilityStyles(styleOptions);
    return (React.createElement(BodyText, { className: classNames("prompt", className ?? "", utilityStyles.utilities), glyph: glyph, glyphColor: color, message: message, textStyle: { bold: true }, role: role ?? undefined, hideMessage: hideMessage }));
};
